import { Container } from 'inversify'
import { Ref, ref } from 'vue'

import {
  CollectorPushMessageEvent,
  SubParticipant,
} from '@collector/sportsapi-client-legacy'
import * as app from '@mobile/globalState/app'
import { RelationIoCBindings } from '@mobile/views/Relation/Shared/RelationDependencies/types'

import { CricketRelationIoCBindings } from '../CricketRelationDependencies'
import { reloadEventSubParticipants, updateSubParticipants } from './utils'

export function bindEventSubParticipants(ioc: Container): void {
  const eventSubParticipants: Ref<SubParticipant[]> = ref([])

  function handleDatabaseEventChange(event: CollectorPushMessageEvent): void {
    updateSubParticipants(
      event.data.participants.flatMap((p) => p.subparticipants),
      eventSubParticipants,
    )
  }

  ioc
    .bind(CricketRelationIoCBindings.EventSubParticipants)
    .toDynamicValue(async () => {
      return eventSubParticipants
    })
    .inSingletonScope()
    .onActivation(async (ctx, eventSubParticipantsRef) => {
      const probableEvent = await ctx.container.getAsync(
        RelationIoCBindings.ProbableEvent,
      )

      await reloadEventSubParticipants(
        probableEvent.value,
        eventSubParticipantsRef,
      )

      app.state.database.events.on('anything', handleDatabaseEventChange)

      return eventSubParticipantsRef
    })
    .when(() => true)
    .onDeactivation(async () => {
      app.state.database.events.off('anything', handleDatabaseEventChange)
    })
    .when(() => true)
}
